// @ts-nocheck

import * as React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import styled, { keyframes } from 'styled-components';

const fadeIn = (opacity?: number | null) => keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: ${opacity || 0.2};
  }
`;

const fadeOut = (opacity?: number | null) => keyframes`
  0% {
    opacity: ${opacity || 0.2};
  }
  100% {
    opacity: 0;
  }
`;

const StyledTransitionGroup = styled(TransitionGroup)`
  .fade-enter {
    animation: ${({ opacity }) => fadeIn(opacity)} 0.2s ease-out forwards;
  }
  .fade-exit {
    animation: ${({ opacity }) => fadeOut(opacity)} 0.2s ease-out forwards;
  }
`;

type OverlayTransitionGroupProps = {
  children?: React.Node;
  opacity?: boolean | null;
};

const OverlayTransitionGroup = ({ children, ...rest }: OverlayTransitionGroupProps) => (
  <StyledTransitionGroup {...rest}>
    {React.Children.map(children, (child, index) =>
      child ? (
        <CSSTransition key={index} timeout={{ enter: 200, exit: 200 }} classNames="fade">
          {child}
        </CSSTransition>
      ) : null,
    )}
  </StyledTransitionGroup>
);

export default OverlayTransitionGroup;
